import { notFound } from '@tanstack/react-router'
import { ApiError } from 'commons/types'
import isInteger from 'lodash/isInteger'

import { getApplicationChangesDetailsWebPage } from './services'
import { ApplicationChangesDetailsWebPage } from './types'

export const applicationChangesDetailsLoader = async ({ params }) => {
  const { applicationId } = params

  const applicationIdRequest = parseInt(applicationId, 10)

  if (!isInteger(applicationIdRequest)) {
    throw notFound()
  }

  let webPage: ApplicationChangesDetailsWebPage | null = null

  try {
    webPage = await getApplicationChangesDetailsWebPage(applicationIdRequest)
  } catch (e) {
    if (e instanceof ApiError && e.httpCode === 400) {
      // let's show 404
      webPage = null
    }
    throw e
  }

  if (!webPage) {
    throw notFound()
  }

  return { webPage, applicationId: applicationIdRequest }
}
